import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06e13fce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center pb-4" }
const _hoisted_2 = { class: "my-8 md:my-16" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-3 text-center shadow-lg w-4/5 m-auto min-h-fit px-8 pt-8 pb-6 gap-y-4" }
const _hoisted_4 = { class: "px-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-left h-full items-start md:col-span-2" }
const _hoisted_7 = { class: "grey-text col-span-12 md:col-span-2" }
const _hoisted_8 = { class: "col-span-8 md:col-span-6" }
const _hoisted_9 = { class: "col-span-3 text-right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "close", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "grey-text col-span-12 md:col-span-2" }
const _hoisted_16 = { class: "col-span-8 md:col-span-6" }
const _hoisted_17 = { class: "col-span-3 text-right" }
const _hoisted_18 = { class: "text-right" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "close", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "grey-text col-span-12 md:col-span-2" }
const _hoisted_23 = { class: "col-span-8 md:col-span-6" }
const _hoisted_24 = { class: "col-span-3 text-right" }
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "close", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "grey-text col-span-12 md:col-span-2" }
const _hoisted_30 = { class: "col-span-8 md:col-span-6" }
const _hoisted_31 = { class: "col-span-3 text-right" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "close", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "grey-text col-span-12 md:col-span-2" }
const _hoisted_37 = { class: "col-span-8 md:col-span-6" }
const _hoisted_38 = { class: "col-span-3 text-right" }
const _hoisted_39 = { class: "text-right" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "close", -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "grey-text col-span-12 md:col-span-2" }
const _hoisted_44 = { class: "col-span-8 md:col-span-6" }
const _hoisted_45 = { class: "col-span-3 text-right" }
const _hoisted_46 = { class: "text-right" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "close", -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "md:col-span-3 mt-4 font-bold text-primary text-right" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Uredi", -1))
const _hoisted_52 = [
  _hoisted_51
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("Povzetek")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _ctx.yardImg,
          class: "mx-auto",
          style: {"width":"285px","height":"180px","background-color":"#ffffff"}
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.tiles.entries(), ([i, tile]) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "grid grid-cols-12 mb-3 pb-2",
            key: tile,
            style: {"border-bottom":"1px solid rgba(229, 231, 235, 1)"}
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("Tlakovec")), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", null, _toDisplayString(tile.title), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(tile.quantity) + " m", 1),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.tiles.length > 1)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.removeItem('tiles',i)),
                    class: "material-icons-round align-middle text-lg pointer text-primary"
                  }, _hoisted_14, 8, _hoisted_12))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.curbs.entries(), ([i, curb]) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "grid grid-cols-12",
            key: curb
          }, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("Robnik")), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(curb.title), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(curb.quantity) + " " + _toDisplayString(curb.priceUnit || 'x'), 1),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", {
                onClick: ($event: any) => (_ctx.removeItem('curbs',i)),
                class: "material-icons-round align-middle text-lg pointer text-primary"
              }, _hoisted_21, 8, _hoisted_19)
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scarpElements.entries(), ([i, element]) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "grid grid-cols-12",
            key: element
          }, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("Škarpni element")), 1),
            _createElementVNode("div", _hoisted_23, _toDisplayString(element.title), 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(element.quantity) + " " + _toDisplayString(element.priceUnit || 'x'), 1),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", {
                onClick: ($event: any) => (_ctx.removeItem('scarpElements',i)),
                class: "material-icons-round align-middle text-lg pointer text-primary"
              }, _hoisted_28, 8, _hoisted_26)
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grouts.entries(), ([i, grout]) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "grid grid-cols-12",
            key: grout
          }, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("Fugirna masa")), 1),
            _createElementVNode("div", _hoisted_30, _toDisplayString(grout.title), 1),
            _createElementVNode("div", _hoisted_31, _toDisplayString(grout.quantity) + " " + _toDisplayString(grout.priceUnit || 'x'), 1),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("span", {
                onClick: ($event: any) => (_ctx.removeItem('grouts',i)),
                class: "material-icons-round align-middle text-lg pointer text-primary"
              }, _hoisted_35, 8, _hoisted_33)
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.impregnation.entries(), ([i, imp]) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "grid grid-cols-12",
            key: imp
          }, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("Impregnacija")), 1),
            _createElementVNode("div", _hoisted_37, _toDisplayString(imp.title), 1),
            _createElementVNode("div", _hoisted_38, _toDisplayString(imp.quantity) + " " + _toDisplayString(imp.priceUnit || 'x'), 1),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("span", {
                onClick: ($event: any) => (_ctx.removeItem('impregnation',i)),
                class: "material-icons-round align-middle text-lg pointer text-primary"
              }, _hoisted_42, 8, _hoisted_40)
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addons.entries(), ([i,addon]) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "grid grid-cols-12",
            key: addon
          }, [
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("Dodatek")), 1),
            _createElementVNode("div", _hoisted_44, _toDisplayString(addon.title), 1),
            _createElementVNode("div", _hoisted_45, _toDisplayString(addon.quantity) + " " + _toDisplayString(addon.priceUnit || 'x'), 1),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("span", {
                onClick: ($event: any) => (_ctx.removeItem('addons',i)),
                class: "material-icons-round align-middle text-lg pointer text-primary"
              }, _hoisted_49, 8, _hoisted_47)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/configure')))
        }, _hoisted_52)
      ])
    ])
  ]))
}